import { useTranslation } from "@redotech/redo-i18n";
import { PaymentMethodOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import type { PaymentMethodState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const PaymentMethodDetails = memo(function PaymentMethodDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<PaymentMethodState>) {
  const { t } = useTranslation();
  const paymentMethodOptions: RedoListItem<PaymentMethodOption>[] = useMemo(
    () =>
      Object.values(PaymentMethodOption).map((method) => ({
        id: method,
        value: method,
        type: "text" as const,
        text:
          method === PaymentMethodOption.GIFT_CARD
            ? t("Gift Card")
            : method === PaymentMethodOption.MANUAL
              ? t("Manual")
              : t("Other"),
      })),
    [t],
  );

  const selectedMethod = state
    ? paymentMethodOptions.find((option) => option.value === state)
    : undefined;

  return (
    <RedoSingleSelectDropdownInput
      disabled={disabled}
      flexGrow
      label={t("Original payment method")}
      options={paymentMethodOptions}
      optionSelected={({ item }) => setState(item.value ?? null)}
      placeholder={t("Select payment method...")}
      selectedItem={selectedMethod}
      size="xs"
    />
  );
});
